import { BaseTabBarItem, BaseTabBarItemProps } from './BaseTabBarItem';

export type TabBarItemProps<K extends string | number> = Pick<
  BaseTabBarItemProps<K>,
  | 'itemKey'
  | 'label'
  | 'icon'
  | 'badge'
  | 'metadata'
  | 'severity'
  | 'aria-controls'
  | 'labelMaxWidth'
>;
/**
 * TabBarItem content can be created by using labels or icons or both.
 */
export function TabBarItem<K extends string | number>({
  itemKey,
  label,
  icon,
  badge,
  metadata,
  severity,
  labelMaxWidth,
  'aria-controls': ariaControls
}: TabBarItemProps<K>) {
  return (
    <BaseTabBarItem
      aria-controls={ariaControls}
      itemKey={itemKey}
      label={label}
      icon={icon}
      badge={badge}
      metadata={metadata}
      severity={severity}
      labelMaxWidth={labelMaxWidth}
    />
  );
}
